import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    inject,
    Inject,
    OnInit,
    Output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDividerComponent } from 'ng-zorro-antd/divider';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzInputDirective } from 'ng-zorro-antd/input';
import { NzMessageModule, NzMessageService } from 'ng-zorro-antd/message';
import {
    NZ_MODAL_DATA,
    NzModalFooterDirective,
    NzModalRef,
    NzModalTitleDirective,
} from 'ng-zorro-antd/modal';
import { NzTableModule } from 'ng-zorro-antd/table';
import { PermissionService } from 'src/app/core/services/permission.service';
import { PermissionDto } from 'src/app/shared/dto/permission.dto';

@Component({
    selector: 'app-modal-add-user-permission',
    templateUrl: './modal-add-user-permission.component.html',
    styleUrl: './modal-add-user-permission.component.scss',
    standalone: true,
    imports: [
        NzTableModule,
        NzModalTitleDirective,
        NzModalFooterDirective,
        NzMessageModule,
        FormsModule,
        NzButtonModule,
        NzDividerComponent,
        NzEmptyModule,
        NzInputDirective,
    ],
})
export class ModalAddUserPermissionComponent implements OnInit {
    @Output() emitService = new EventEmitter<PermissionDto>();

    isLoading = true;
    searchText = '';

    availablePermissions: PermissionDto[] = [];
    filteredPermissions: PermissionDto[] = [];

    private readonly modalRef = inject(NzModalRef);
    private readonly permissionService = inject(PermissionService);
    private readonly message = inject(NzMessageService);
    private readonly cdr = inject(ChangeDetectorRef);

    constructor(
        @Inject(NZ_MODAL_DATA)
        public data: {
            nzTitle: string;
            userId: number;
        },
    ) {}

    async ngOnInit() {
        try {
            this.availablePermissions = await this.permissionService.findAvailableForUser(this.data.userId);
            this.filteredPermissions = [...this.availablePermissions];
        } catch (e) {
            this.message.error('Error al cargar los permisos disponibles.');
            console.error(e);
        } finally {
            this.isLoading = false;
            this.cdr.markForCheck();
        }
    }

    onSearch() {
        const text = this.searchText.toLowerCase().trim();
        if (!text) {
            this.filteredPermissions = [...this.availablePermissions];
        } else {
            this.filteredPermissions = this.availablePermissions.filter(
                (p) =>
                    p.mainkey.toLowerCase().includes(text) ||
                    p.key.toLowerCase().includes(text),
            );
        }
    }

    selectPermission(permission: PermissionDto) {
        this.emitService.next(permission);
        this.availablePermissions = this.availablePermissions.filter(p => p.id !== permission.id);
        this.onSearch();
        this.cdr.markForCheck();
    }

    handleCancel() {
        this.modalRef.close();
    }
}
